import { addShortPut } from './addOption';
import { StrategyBuilderFunction, EMPTY_STRATEGY } from './types';
import {
  getDefaultExpiration,
  findClosestStrikePrice,
  getStrikesAtExpiration,
  expirationToDate,
  getPremium,
  getStrategyLegStrikeDirection,
} from './utils';

export const shortPut: StrategyBuilderFunction = ({
  chain,
  spot,
  expirationDate,
  expirationKey,
  strike,
  strikeDirection,
  contractMultiplier = 1,
  // premiumMultiplier = 1,
  // expirationMultiplier = 1,
}) => {
  const strikesAtExpiration = expirationKey
    ? getStrikesAtExpiration(chain, expirationKey)
    : getDefaultExpiration(chain);

  if (
    !strikesAtExpiration ||
    !strikesAtExpiration.e ||
    !strikesAtExpiration.ey ||
    !strikesAtExpiration.em ||
    !strikesAtExpiration.ed
  ) {
    return EMPTY_STRATEGY;
  }

  const strikeForStrategy = strike ? strike : findClosestStrikePrice(strikesAtExpiration!, spot);

  const expirationDateForOption =
    expirationDate ||
    expirationToDate(strikesAtExpiration.ey, strikesAtExpiration.em, strikesAtExpiration.ed);
  const expirationKeyForOption = expirationKey || strikesAtExpiration.e;
  const premiumForStrategy = getPremium({
    ask: strikesAtExpiration?.c?.[strikeForStrategy]?.p?.a || 0,
    bid: strikesAtExpiration?.c?.[strikeForStrategy]?.p?.b || 0,
    strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'short'),
  });

  return {
    optionPositions: [
      addShortPut({
        strike: strikeForStrategy,
        premium: premiumForStrategy,
        expirationDate: expirationDateForOption,
        expirationKey: expirationKeyForOption,
        numberOfContracts: 1 * contractMultiplier,
      }),
    ],
    stockPositions: [],
  };
};
